// Chat interno del equipo (D71). Los mensajes viven en el CRM (objeto mensajeInterno) con los permisos de cada persona;
// el servicio de tiempo real solo los reparte al instante.
import { type MensajeChat } from '../lib/tiempoReal';
import { create, f, listAll } from './rest';

export const canalDirecto = (a: string, b: string) => `dm:${[a.toLowerCase(), b.toLowerCase()].sort().join(':')}`;

export async function mensajesDe(canal: string, limite = 80): Promise<MensajeChat[]> {
  const xs = await listAll<MensajeChat>('mensajesInternos', { filter: f.eq('canal', canal), orderBy: 'createdAt[DescNullsLast]', depth: 0 }, limite);
  return xs.reverse();
}

// Ultimos mensajes de todos los canales que la persona puede ver (para la lista de canales y los no leidos).
export async function recientes(miembroId: string, desde: string): Promise<MensajeChat[]> {
  const xs = await listAll<MensajeChat>('mensajesInternos', { filter: f.gte('createdAt', desde), orderBy: 'createdAt[DescNullsLast]', depth: 0 }, 300);
  const yo = miembroId.toLowerCase();
  return xs.filter((m) => !m.canal.startsWith('dm:') || m.canal.split(':').slice(1).includes(yo));
}

// @Nombre en el texto -> ids de los miembros mencionados.
export function mencionesEn(texto: string, miembros: { id: string; nombre: string }[]) {
  const t = texto.toLowerCase();
  return miembros.filter((m) => m.nombre && t.includes(`@${m.nombre.split(/\s+/)[0].toLowerCase()}`)).map((m) => m.id);
}

export const enviarMensaje = (d: { canal: string; texto: string; autorId: string; menciones: string[]; titulo?: string }) =>
  create<MensajeChat>('mensajesInternos', { name: d.texto.slice(0, 4000), canal: d.canal, autorId: d.autorId, menciones: d.menciones, titulo: d.titulo ?? null });
